import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { FaStar, FaQuoteLeft, FaArrowLeft, FaArrowRight } from "react-icons/fa";

const TESTIMONIALS = [
  {
    id: 1,
    name: "Mr. Rajesh Deshmukh",
    role: "Corporate Manager",
    text:
      "Amruta Travels arranged our Pune–Goa corporate retreat flawlessly. The driver was punctual, polite, and the Urbania was spotless and extremely comfortable. Truly professional service!",
  },
  {
    id: 2,
    name: "Mrs. Kavita More",
    role: "Family Traveler",
    text:
      "We booked Amruta Travels for our Shirdi family trip — it was a wonderful experience! Spacious seats, smooth driving, and timely service made our journey stress-free and safe.",
  },
  {
    id: 3,
    name: "Mr. Sandeep Gawade",
    role: "Entrepreneur",
    text:
      "I often travel between Pune and Mumbai for business. Amruta Travels has been my go-to for reliable and comfortable rides. Their pricing is transparent and service is always on time.",
  },
  {
    id: 4,
    name: "Ms. Pooja Kamat",
    role: "Tour Coordinator",
    text:
      "Amruta Travels handled our college industrial visit transport. The buses were clean, well-maintained, and the staff was courteous. Highly recommended for group tours and long trips!",
  },
];


export default function TestimonialsAmruta() {
  return (
    <section
      className="testimonials-amruta section-space"
      style={{
        background: "linear-gradient(135deg, #001f3f, #0072bc)",
        color: "#fff",
        position: "relative",
        overflow: "hidden",
        padding: "80px 0",
      }}
    >
      {/* Header Section */}
      <div className="container text-center mb-5">
        <h6 className="text-uppercase" style={{ letterSpacing: "2px" }}>
          Testimonials
        </h6>
        <h2 className="fw-bold mb-3" style={{ color: "#fff" }}>
          What Our Clients Say
        </h2>
        <p style={{ color: "rgba(255,255,255,0.85)" }}>
          Trusted by thousands of travelers for reliable, comfortable, and
          premium cab services.
        </p>
      </div>

      {/* Swiper Section */}
      <div className="container position-relative">
        <Swiper
          modules={[Navigation, Autoplay]}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          loop
          navigation={{
            nextEl: ".amruta-next",
            prevEl: ".amruta-prev",
          }}
          spaceBetween={30}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
          }}
        >
          {TESTIMONIALS.map((t) => (
            <SwiperSlide key={t.id}>
              <div
                className="testimonial-card"
                style={{
                  background: "#fff",
                  color: "#000",
                  borderRadius: "16px",
                  padding: "30px 24px",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                  position: "relative",
                  transition: "transform 0.3s, box-shadow 0.3s",
                }}
              >
                {/* Quote icon */}
                <FaQuoteLeft
                  size={36}
                  color="#0072bc"
                  style={{
                    position: "absolute",
                    top: "20px",
                    right: "20px",
                    opacity: 0.1,
                  }}
                />

                {/* Top section */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>
                    <h5 className="fw-bold mb-0">{t.name}</h5>
                    <small className="text-muted">{t.role}</small>
                  </div>
                </div>

                {/* Review text */}
                <p
                  className="mt-3 mb-3"
                  style={{ color: "#333", fontStyle: "italic" }}
                >
                  “ {t.text} ”
                </p>

                {/* Stars */}
                <div style={{ color: "#0072bc" }}>
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation arrows */}
        <div
          className="d-flex justify-content-center align-items-center gap-3 mt-4"
          style={{ color: "#fff" }}
        >
          <button
            className="amruta-prev btn"
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              background: "#ffffff",
              color: "#0072bc",
              border: "none",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              transition: "0.3s",
            }}
          >
            <FaArrowLeft />
          </button>
          <button
            className="amruta-next btn"
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              background: "#ffffff",
              color: "#0072bc",
              border: "none",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              transition: "0.3s",
            }}
          >
            <FaArrowRight />
          </button>
        </div>
      </div>
    </section>
  );
}
